var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"xs":24,"md":18,"lg":16,"xl":12}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }